import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["container", "id", "name", "disabled", "visible", "placeholder", "type", "value", "readonly", "required", "maxlength", "size", "min", "max", "autocomplete", "pattern"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomValidate = _resolveComponent("CustomValidate")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          container: _ctx.container,
          id: _ctx.getPropertyValue(_ctx.InputTypeConst.ID),
          style: _normalizeStyle(_ctx.getPropertyValue(_ctx.InputTypeConst.STYLE)),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
          class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.InputTypeConst.CLASS) ?? '']: true, 'p-invalid': _ctx.v$.vmodel.$error && _ctx.submitted,'p-readonly': _ctx.getPropertyBooleanValue(_ctx.InputTypeConst.READONLY) }),
          name: _ctx.getPropertyValue(_ctx.InputTypeConst.NAME),
          disabled: _ctx.getPropertyBooleanValue(_ctx.InputTypeConst.DISABLED) || (!_ctx.canEdit),
          visible: _ctx.getPropertyBooleanValue(_ctx.InputTypeConst.VISIBLE),
          placeholder: _ctx.getPropertyValue(_ctx.InputTypeConst.PLACEHOLDER),
          type: _ctx.getCatalogValue(_ctx.InputTypeConst.TYPE),
          value: _ctx.getPropertyValue(_ctx.InputTypeConst.VALUE),
          readonly: _ctx.getPropertyBooleanValue(_ctx.InputTypeConst.READONLY),
          required: _ctx.getPropertyBooleanValue(_ctx.InputTypeConst.REQUIRED),
          maxlength: _ctx.getPropertyNumberValue(_ctx.InputTypeConst.MAXLENGTH),
          size: _ctx.getPropertyNumberValue(_ctx.InputTypeConst.SIZE),
          min: _ctx.getPropertyNumberValue(_ctx.InputTypeConst.MIN),
          max: _ctx.getPropertyNumberValue(_ctx.InputTypeConst.MAX),
          autocomplete: _ctx.getPropertyValue(_ctx.InputTypeConst.AUTOCOMPLETE),
          pattern: _ctx.getPropertyValue(_ctx.InputTypeConst.PATTERN)
        }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1)), [
          [_directive_tooltip, _ctx.getPropertyValue(_ctx.InputTypeConst.TOOLTIP)],
          [_vModelDynamic, _ctx.vmodel]
        ])
      : _createCommentVNode("v-if", true),
    (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
      ? (_openBlock(), _createBlock(_component_CustomValidate, {
          key: 1,
          submitted: _ctx.submitted,
          "onUpdate:submitted": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitted) = $event)),
          vObject: _ctx.v$,
          "onUpdate:vObject": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$) = $event))
        }, null, 8 /* PROPS */, ["submitted", "vObject"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}